<template>
  <div class="time-of-day">
    <img :src="background">
    <transition name="fade">
      <img
        :key="selectedLayer.img"
        class="icon-overlay"
        :src="selectedLayer.img"
        :class="`layer-${selectedLayer.id}`"
        alt="Time of day illustration"
      >
    </transition>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'

export default {
  name: 'TimeOfDayIcon',
  props: {
    question: {
      type: Object,
      required: true
    },
    answer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      background: require('@/assets/answer-icons/internet-times/bg.svg'),
      layers: [

        {
          values: ['day'],
          id: 'bar0',
          img: require('@/assets/answer-icons/internet-times/day.svg')
        },
        {
          values: ['evening'],
          id: 'bar1',
          img: require('@/assets/answer-icons/internet-times/evening.svg')
        },
        {
          values: ['night'],
          id: 'bar2',
          img: require('@/assets/answer-icons/internet-times/night.svg')
        },
        {
          values: ['day', 'evening'],
          id: 'bar3',
          img: require('@/assets/answer-icons/internet-times/day-evening.svg')
        },
        {
          values: ['day', 'night'],
          id: 'bar4',
          img: require('@/assets/answer-icons/internet-times/day-night.svg')
        },
        {
          values: ['evening', 'night'],
          id: 'bar4',
          img: require('@/assets/answer-icons/internet-times/evening-night.svg')
        },
        {
          values: ['day', 'evening', 'night'],
          id: 'bar4',
          img: require('@/assets/answer-icons/internet-times/day-evening-night.svg')
        }
      ]
    }
  },

  computed: {
    totalScore () {
      return this.answer.result.reduce((total, ans) => total + ans.score, 0)
    },
    selectedLayer () {
      if (!this.answer || !this.answer.result) return false
      let selectedValues = this.answer.result.reduce((arr, result) => [...arr, result.value], [])

      return this.layers.find(layer => isEqual(layer.values.sort(), selectedValues.sort()))
    }
  }
}
</script>

<style scoped lang="scss">
.icon-overlay {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
}

.indicator {
    position: absolute;
    bottom: 35%;
    width: 10px;
    left: calc(50% - 5px);
    transform-origin: 50% 80%;
    transform: rotate(-95deg);
    transition: all 1s cubic-bezier(0.625, 0.155, 0.000, 1.125);

    &.bar1 {
      transform: rotate(-85deg);
    }

    &.bar2 {
      transform: rotate(-40deg);
    }

    &.bar3 {
      transform: rotate(25deg);
    }

    &.bar4 {
      transform: rotate(90deg);
    }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
